import { reactive, onMounted } from 'vue';
import { useHomeStore } from "../../../store/home"; //引入home仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Autoplay, Pagination } from "swiper";
import 'swiper/swiper.min.css'; // import 'swiper/modules/effect-fade/effect-fade.min.css'  //引入轮播样式-淡入淡出的css样式

SwiperCore.use([Autoplay, Pagination]);
export default {
  name: "Carousel",
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  setup: function setup() {
    var store = useHomeStore();
    var swiper_option = reactive({
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      loop: true,
      speed: 1000,
      liner: true,
      pagination: {
        clickable: true
      }
    });
    onMounted(function () {
      store.getBannerList();
    });

    var _storeToRefs = storeToRefs(store),
        bannerList = _storeToRefs.bannerList; //从仓库获取数据


    return {
      bannerList: bannerList,
      swiper_option: swiper_option
    };
  }
};